import { render, staticRenderFns } from "./ReferralCommercialTerms.vue?vue&type=template&id=9253865c&"
import script from "./ReferralCommercialTerms.vue?vue&type=script&lang=js&"
export * from "./ReferralCommercialTerms.vue?vue&type=script&lang=js&"
import style0 from "./ReferralCommercialTerms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports